import { GoogleAnalyticsEventType } from 'enums/GoogleAnalyticsEventType';
import { useCurrentStep } from 'hooks/useCurrentStep';
import useGoogleAnalytics from 'hooks/useGoogleAnalytics';

import { SignLoanAgreementSteps } from './constants';
import GeneralStep from './steps/GeneralStep';
import OneSpanSignWidget from './steps/OneSpanSignWidget';
import SendApplicationForFundingStep from './steps/SendApplicationForFundingStep';

const SignLoanAgreementStep = () => {
  const trackEvent = useGoogleAnalytics();
  const [currentStep, setCurrentStep] = useCurrentStep<SignLoanAgreementSteps>(
    SignLoanAgreementSteps.GeneralStep,
  );

  const handleSignClick = () => {
    setCurrentStep(SignLoanAgreementSteps.OneSpanSignWidgetStep);
    trackEvent(GoogleAnalyticsEventType.ApplyProcessLoanDocs);
  };

  const renderCurrentStep = () => {
    switch (currentStep) {
      case SignLoanAgreementSteps.GeneralStep:
        return <GeneralStep onContinueClick={handleSignClick} />;
      case SignLoanAgreementSteps.OneSpanSignWidgetStep:
        return (
          <OneSpanSignWidget
            onStepComplete={() =>
              setCurrentStep(SignLoanAgreementSteps.SendApplicationForFundingStep)
            }
          />
        );
      case SignLoanAgreementSteps.SendApplicationForFundingStep:
        return <SendApplicationForFundingStep />;
      default:
        return null as never;
    }
  };

  return renderCurrentStep();
};

export default SignLoanAgreementStep;
